/**
 * Classic DataTables-style pagination summary:
 * "Showing 1 to 25 of 57 entries (filtered from 100 total entries)"
 */
export function formatIndexPaginationSummary({
  page = 1,
  itemsPerPage = 25,
  filtered = 0,
  total = null,
  noun = 'entries',
} = {}) {
  const filteredCount = Math.max(0, Number(filtered) || 0)
  const totalCount = total == null ? filteredCount : Math.max(0, Number(total) || 0)
  const per = Number(itemsPerPage)
  const nounLabel = noun || 'entries'

  if (filteredCount === 0) {
    let text = `Showing 0 ${nounLabel}`
    if (totalCount > 0) {
      text += ` (filtered from ${totalCount} total ${nounLabel})`
    }
    return text
  }

  let start
  let end
  if (!Number.isFinite(per) || per < 0) {
    // "All" rows on one page
    start = 1
    end = filteredCount
  } else {
    const safePer = per || 25
    const safePage = Math.max(1, Number(page) || 1)
    start = (safePage - 1) * safePer + 1
    end = Math.min(safePage * safePer, filteredCount)
  }

  let text = `Showing ${start} to ${end} of ${filteredCount} ${nounLabel}`
  if (filteredCount !== totalCount) {
    text += ` (filtered from ${totalCount} total ${nounLabel})`
  }
  return text
}
